import Tabs from './Tabs';
import TabPane from './TabPane';
import TabContent from './TabContent';

export default Tabs;
export { TabPane, TabContent };


//////////////////
// WEBPACK FOOTER
// ../~/rc-tabs/es/index.js
// module id = 2032
// module chunks = 1